import { PaginatedList } from "@/datastructures/PaginatedList";
import { FormResponse } from "@/forms/FormResponse";
import { ISupplierOrderOverviewPresenter } from "../controllers/SupplierOrderOverviewController";
import { SupplierOrderOverviewViewModel } from "../vms/SupplierOrderOverviewViewModel";

export class SupplierOrderOverviewPresenter
  implements ISupplierOrderOverviewPresenter {
  public mounting = true;

  public constructor(private vm: SupplierOrderOverviewViewModel) {}

  public set getSuppliersResponse(response: FormResponse<any[]>) {
    this.vm.loading = response.loading;

    if (!response.loading && !response.error) {
      this.vm.supplierFilter.items = response.data.map(el => ({
        text: el.name,
        value: el.id
      }));
    }
  }

  public set tableRequest(response: FormResponse<PaginatedList<any>>) {
    this.vm.loading = response.loading;

    if (!response.loading && !response.error) {
      this.vm.items = response.data.items.map(el => ({
        ...el,
        supplierName: el.supplier.firstName
          ? `${el.supplier.lastName.toLocaleUpperCase()}, ${
              el.supplier.firstName
            }`
          : el.supplier.company,
        employeeName: `${el.employee.lastname.toLocaleUpperCase()}, ${
          el.employee.firstname
        }`
      }));
      this.vm.totalItems = response.data.totalCount;

      this.mounting = false;
    }
  }

  public get pageNumber() {
    return this.vm.pageNumber;
  }

  public set pageNumber(pageNumber: number) {
    this.vm.pageNumber = pageNumber;
  }

  public get itemsPerPage() {
    return this.vm.itemsPerPage;
  }

  public get options() {
    return this.vm.options;
  }

  public set options(options: any) {
    this.vm.options = options;
  }

  public set deleteRequest(response: FormResponse<string>) {
    this.vm.loading = response.loading;
  }

  public get supplierFilter() {
    return this.vm.supplierFilter;
  }

  public get search() {
    return this.vm.search;
  }
}
